import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroupDirective,
  NgForm,
  Validators
} from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

import {ForgetPasswordService} from '../forgetpassword/forgetpasswor.services';
import {AuthLayoutComponent} from '../layouts/auth/auth-layout.component';
import { Router } from '@angular/router';
import {AuthService} from '../services/auth.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}
@Component({
  selector: 'app-forgetpassword',
  templateUrl: './forgetpassword.component.html',
  styleUrls: ['./forgetpassword.component.css']
})
export class ForgetPasswordComponent implements OnInit {
  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email
  ]);
  matcher = new MyErrorStateMatcher();

  // tslint:disable-next-line:no-shadowed-variable
  constructor(private AuthService: AuthService, public router: Router, public forgetpasswordservice: ForgetPasswordService, public auth: AuthLayoutComponent) {}

  ngOnInit() {}

  forgetpassword() {
   this.auth.active = true;
   this.AuthService.forgetpassword(this.emailFormControl.value);
   this.auth.active =false;
  }
}
